import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

interface MobileHeaderBarProps {
  onMenuOpen: () => void;
  title?: string;
}

export const MobileHeaderBar: React.FC<MobileHeaderBarProps> = ({
  onMenuOpen,
  title = "HEXTRANOLO",
}) => {
  const theme = useTheme();
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        boxShadow: "none",
        borderBottom: "none",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 48,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuOpen}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
